import { PopupContext } from '@/contexts/PopupContext';
import { useExtendFocusable } from '@/hooks/useExtendFocusable';
import { FocusContext } from '@noriginmedia/norigin-spatial-navigation';
import { useCallback, useContext, useEffect } from 'react';

export const PopUpModal = () => {
  const { popupData } = useContext(PopupContext);
  const { ref, focusSelf, focusKey } = useExtendFocusable({
    isFocusBoundary: true,
    trackChildren: true,
    focusable: popupData.open,
  });

  const handlePopupClick = useCallback((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
  }, []);

  useEffect(() => {
    if (!popupData.open) return;
    focusSelf();
  }, [popupData.open, focusSelf]);

  return (
    <FocusContext.Provider value={focusKey}>
      {popupData.open && (
        <div
          className="fixed inset-0 z-50 flex justify-center items-center bg-[rgba(0,0,0,0.5)] top-0 w-full h-full"
          onClick={popupData.onClose}
          onContextMenu={popupData.onClose}
        >
          <div
            ref={ref}
            className="bg-white flex justify-center items-center rounded-[30px]"
            onClick={handlePopupClick}
          >
            {popupData.children}
          </div>
        </div>
      )}
    </FocusContext.Provider>
  );
};
